<template>
  <div v-if="show" class="modal-backdrop">
    <div class="modal-content" style="max-width: 500px;">
      <div class="modal-header">
        <h3 class="modal-title">Bulk Upload Designations</h3>
        <button type="button" class="btn-close" @click="close" title="Close"><i class="bx bx-x"></i></button>
      </div>

      <div class="modal-body">
        <p class="text-muted mb-4">Upload a CSV or Excel file containing Designations and Job Groups. The file must have columns named "Designation Name" and "Job Group".</p>

        <div class="form-group mb-3">
          <label for="uploadFile" class="form-label">Select File (CSV, XLS, XLSX) <span class="text-danger">*</span></label>
          <input 
            type="file" 
            class="form-control" 
            id="uploadFile" 
            ref="fileInput" 
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            @change="handleFileChange"
          >
        </div>

        <div v-if="fileName" class="selected-file mt-2">
          <i class="bx bx-file"></i> {{ fileName }}
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="close">Cancel</button>
        <button type="button" class="btn btn-primary" @click="uploadFile" :disabled="loading || !selectedFile">
          <i v-if="loading" class="bx bx-loader-alt bx-spin"></i>
          <span v-else>Upload</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { authUrl, execute } from "@/api";

export default {
  name: "BulkUploadPositionsModal",
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selectedFile: null,
      fileName: '',
      loading: false
    };
  },
  methods: {
    close() {
      this.selectedFile = null;
      this.fileName = '';
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
      this.$emit('close');
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.fileName = file.name;
      }
    },
    uploadFile() {
      if (!this.selectedFile) return;

      this.loading = true;
      const data = new FormData();
      data.append("function", "bulkUploadPositions");
      data.append("file", this.selectedFile);

      execute(data, authUrl)
        .then((res) => {
          this.loading = false;
          const d = res?.data;
          if (d && d.success) {
            alert(d.message || "File uploaded successfully");
            this.$emit('uploaded');
            this.close();
          } else {
            alert(d?.message || "Failed to upload file");
          }
        })
        .catch((e) => {
          this.loading = false;
          alert("Error uploading file: " + (e?.message || "Unknown error"));
        });
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-content {
  background: white;
  border-radius: 8px;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
}
.modal-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #dee2e6;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-title {
  margin: 0;
  font-size: 1.25rem;
}
.btn-close {
  background: transparent;
  border: 0;
  font-size: 1.5rem;
  cursor: pointer;
}
.modal-body {
  padding: 1.5rem;
}
.modal-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #dee2e6;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}
.selected-file {
  font-size: 0.9rem;
  color: #6c757d;
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.btn {
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
}
.btn-primary {
  background-color: #0d6efd;
  color: white;
}
.btn-secondary {
  background-color: #6c757d;
  color: white;
}
</style>
